import { Injectable } from '@angular/core';
import { CommandDefinition, CommandHelper, CommandResultEntry } from '@app/shared/quick-commands';
import { PortalTranslateService } from '@app/translate/services/portal-translate.service';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SwitchLanguageCommand implements CommandDefinition<string> {
  async = false;
  label = 'quickCommands.commands.switchLanguage';
  icon = 'far fa-language';
  name = 'switchLanguage';

  constructor(private portalTranslateService: PortalTranslateService) {}

  action(_: string, [language]: [string]) {
    if (language != null) {
      this.portalTranslateService.use(language);

      return CommandHelper.close();
    }

    return CommandHelper.list$(
      forkJoin([
        this.portalTranslateService.languageKeys$.pipe(first()),
        this.portalTranslateService.activeLanguage$.pipe(first()),
      ]),
      ([languages, activeLanguage]) => {
        return {
          filterAutomatically: true,
          values: languages.map((language): CommandResultEntry<string> => {
            return {
              active: language.toLowerCase() === activeLanguage.toLowerCase(),
              label: `portal.language.${language.toUpperCase()}`,
              value: language,
            };
          }),
        };
      }
    );
  }
}
